import React from "react";
import { Box, Paper, InputBase, IconButton } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { useNavigate } from "react-router-dom";

const SearchBox = ({
  query,
  setQuery,
  suggestions,
  categories,
  showDropdown,
  setShowDropdown,
}) => {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowDropdown(false);
    navigate(`/search?q=${query}`);
  };

  return (
    <Box sx={{ position: "relative", width: "100%", maxWidth: 800 }}>
      <Paper
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: "flex",
          alignItems: "center",
          height: 40,
        }}
      >
        <InputBase
          placeholder="Search Pepper Diamond"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => query && setShowDropdown(true)}
          sx={{ ml: 2, flex: 1 }}
        />
        <IconButton
          type="submit"
          sx={{
            bgcolor: "#ff9900",
            px: 2,
            py: 0,
            height: 40,
            borderRadius: "0 4px 4px 0",
            "&:hover": { bgcolor: "#e68a00" },
          }}
        >
          <SearchOutlinedIcon sx={{ color: "#fff", fontSize: 22 }} />
        </IconButton>
      </Paper>

      {/* 🔥 AUTOCOMPLETE DROPDOWN */}
      {showDropdown && (suggestions.length > 0 || categories.length > 0) && (
        <Paper
          sx={{
            position: "absolute",
            top: 45,
            width: "100%",
            zIndex: 2000,
            maxHeight: 400,
            overflowY: "auto",
          }}
        >
          {/* Categories */}
          {categories.length > 0 && (
            <>
              <Box sx={{ px: 2, py: 1, fontWeight: 600 }}>Categories</Box>
              {categories.map((cat) => (
                <Box
                  key={cat._id}
                  sx={{
                    px: 2,
                    py: 1,
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                  onClick={() => {
                    setShowDropdown(false);
                    navigate(`/search?q=${cat.name}`);
                  }}
                >
                  🔎 {cat.name}
                </Box>
              ))}
            </>
          )}

          {/* Products */}
          {suggestions.length > 0 && (
            <>
              <Box sx={{ px: 2, py: 1, fontWeight: 600 }}>Products</Box>
              {suggestions.map((p) => (
                <Box
                  key={p._id}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    px: 2,
                    py: 1,
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                  onClick={() => {
                    setShowDropdown(false);
                    navigate(`/product/${p._id}`);
                  }}
                >
                  <img
                    src={p.thumbnailUrl || "/placeholder-product.png"}
                    width={40}
                    height={40}
                    style={{ objectFit: "cover", borderRadius: 4 }}
                    alt={p.title}
                  />
                  {p.title}
                </Box>
              ))}
            </>
          )}
        </Paper>
      )}
    </Box>
  );
};

export default SearchBox;